export default {
      id: "financial-risk-2-usage",
      viewBox: "0 0 74 92",
      url: __webpack_public_path__ + "sprite.svg#financial-risk-2",
      toString: function () {
        return this.url;
      }
    }